// extracted by mini-css-extract-plugin
export default {"margin":"Zone_margin__u+bHE","zones":"Zone_zones__yjZsw"};